import React from 'react';

// Fitness Assessment V2 · Phase 2 — Performance Category badge.
//
// Server is the source of truth (see backend
// services/assessment_standards.py). The badge renders whatever the
// backend classifier returned without recomputing.
//
// UI contract:
//   color_key  | badge look
//   -----------+--------------------------------------------------
//   green      | Excellent
//   blue       | Good
//   amber      | Standard (doc says "Regular")
//   red        | Needs Improvement (doc says "Below")
//   gray       | Unclassified / Pending Calculation

const COLOR_CLASSES = {
  green: 'bg-emerald-100 text-emerald-800 border-emerald-200 dark:bg-emerald-900/30 dark:text-emerald-300 dark:border-emerald-800',
  blue:  'bg-blue-100 text-blue-800 border-blue-200 dark:bg-blue-900/30 dark:text-blue-300 dark:border-blue-800',
  amber: 'bg-amber-100 text-amber-800 border-amber-200 dark:bg-amber-900/30 dark:text-amber-300 dark:border-amber-800',
  red:   'bg-rose-100 text-rose-800 border-rose-200 dark:bg-rose-900/30 dark:text-rose-300 dark:border-rose-800',
  gray:  'bg-gray-100 text-gray-600 border-gray-200 dark:bg-gray-900 dark:text-gray-400 dark:border-gray-700',
};

export const PerformanceBadge = ({
  label,
  colorKey = 'gray',
  reason,
  testId,
  size = 'sm',
}) => {
  const cls = COLOR_CLASSES[colorKey] || COLOR_CLASSES.gray;
  const pad = size === 'md' ? 'px-3 py-1 text-xs' : 'px-2.5 py-0.5 text-[11px]';
  return (
    <span
      className={`inline-flex items-center rounded-full border font-medium ${pad} ${cls}`}
      title={reason || undefined}
      data-testid={testId}
    >
      {label || 'Unclassified'}
    </span>
  );
};

export default PerformanceBadge;
